import { Component } from '@angular/core';

@Component({
  selector: 'app-suggested-sites',
  templateUrl: './suggested-sites.component.html',
  styleUrl: './suggested-sites.component.scss',
})
export class SuggestedSitesComponent {
  items = [
    {
      title: 'مواقع حكومية ',
      content: [
        { name: 'بوابة الحكومة المصرية', url: '' },
        {
          name: 'وزارة الصناعة والتجارة والمشروعات الصغيرة والمتوسطة',
          url: '',
        },
        {
          name: 'وزارة الكهرباء والطاقة المتجددة',
          url: '',
        },
        { name: 'الممثل التجاري المصري', url: '' },
        { name: 'مركز تحديث الصناعة', url: '' },
        {
          name: 'الهيئة العامة للتنمية الصناعية',
          url: '',
        },
        {
          name: 'الوكالة الإقليمية للاستثمار الكومبسا ( RIA )',
          url: '',
        },
        { name: 'مركزك شركتك', url: '' },
      ],
      expanded: false,
    },
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
